import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContributionsHomeComponent } from './home/contributions-home.component';
import { ContributionsFiltersComponent } from './contributions-filters/contributions-filters.component';
import { ContributionsRoutingModule } from './contributions-routing.module';
import { LoaderGlobeAnimationDetailComponent } from '../loaders';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { AvatarPillComponent, CommentsPostDisplayPaginationAllInOneComponent, InlinePillPickerComponent, InsightMarkdownPipe, LinksModule, MultilingualFormsModule, PaginationModule, IconPillComponent, UploadersModule } from '@frontend/shared';
import { DeliveryStatusCardComponent } from './delivery-status-card/delivery-status-card.component';
import { DeliverableEditParentComponent } from './deliverable-edit-parent/deliverable-edit-parent.component';
import { InsightEditComponent } from './insight-edit/insight-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { RichTextEditorBasicCustomBuildModule, RichTextEditorReactiveFormInputModule } from '@frontend/ckeditor';
import { ProgressIndicatorDoughnutModule } from '../tracking';
import { NationalCultureVisualisationModule } from '../cultures/national-culture-visualisation';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import { RandomisedMessageCardComponent } from '../content/message';
import { ScoreHighlightModule } from '../content/cards';
import { DifferenceVoteCcoComponent } from './difference-vote-cco/difference-vote-cco.component';
import { FormControlLickertQuestionComponent } from '../forms';
import { DeliverableService } from './deliverable.service';
import { ContributionAnonymityLevelFormModule } from './anonymity-level-form/anonymity-level-form.module';
import { CultureSelectorTypeOneModule } from '../cultures';

@NgModule({
    declarations: [
        ContributionsHomeComponent,
        ContributionsFiltersComponent,
        DeliveryStatusCardComponent,
        DeliverableEditParentComponent,
        InsightEditComponent,
        // ContributionAnonymityLevelFormComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TypeaheadModule,
        CollapseModule,
        ContributionsRoutingModule,
        LoaderGlobeAnimationDetailComponent,
        TranslocoModule,
        LinksModule,
        PaginationModule,
        AvatarPillComponent,
        MultilingualFormsModule,
        UploadersModule,
        IconPillComponent,
        RichTextEditorBasicCustomBuildModule, // Our own library
        RichTextEditorReactiveFormInputModule,
        FormsModule,
        ProgressIndicatorDoughnutModule,
        NationalCultureVisualisationModule,
        InlinePillPickerComponent,
        InsightMarkdownPipe,
        ModalModule, 
        AlertModule,
        CommentsPostDisplayPaginationAllInOneComponent,
        ScoreHighlightModule,
        RandomisedMessageCardComponent,
        FormControlLickertQuestionComponent,
        DifferenceVoteCcoComponent,
        PaginationModule,
        ContributionAnonymityLevelFormModule,
        CultureSelectorTypeOneModule
    ],
    exports: [
        ContributionsFiltersComponent,
        // ContributionsHomeComponent,
    ],
    providers: [
        { provide: TRANSLOCO_SCOPE, useValue: 'contributions' },
        DeliverableService,
    ],
})
export class ContributionsModule { }